interface Dictionary<T> {
  [index: string]: T;
}

export const colorsDictionary: Dictionary<string> = {
  'door-color-1': '#292A30',
  'door-color-2': '#50575A',
  'door-color-3': '#4D3827',
  'door-color-4': '#8D7B66',
  'door-color-5': '#D7BEAF',
};
